export const BEST_CONTACT_TIMES = {
  early: 'Early morning (before 9am)',
  morning: 'Morning (9am - noon)',
  lunch: 'Lunch time (noon - 1pm)',
  afternoon: 'Afternoon (1pm - 5pm)',
  evening: 'Evening (after 5pm)',
};
